import userMixin from './user';

export default {
  mixins: [userMixin],
  methods: {
    hasAccessVehicle(vehicle) {
      const company = vehicle.company || {};
      return this.iHaveAccess('MAIN.VEHICLE.READ') &&
        (this.amISystemAdmin || this.isMyCompany(company.id));
    },
    canICreateVehicle(companyId = null) {
      const haveAccess = this.iHaveAccess('MAIN.VEHICLE.CREATE');
      if (companyId === null) {
        return haveAccess;
      }

      return haveAccess &&
        (this.amISystemAdmin || this.isMyCompany(companyId));
    },
    canIEditVehicle(vehicle) {
      return this.iHaveAccess('MAIN.VEHICLE.UPDATE') &&
        this.hasAccessVehicle(vehicle);
    },
    canIDeleteVehicle(vehicle) {
      return this.iHaveAccess('MAIN.VEHICLE.DELETE') &&
        this.hasAccessVehicle(vehicle);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/vehicle.js